import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { Form, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';
import { GestionCgChargeComponent } from 'src/app/core/gestion-referentiel/gestion-cg-charge/gestion-cg-charge.component';
import { PeriodeSageModel } from 'src/app/shared/models/societe-linked/periode-sage.model';
import { PeriodeSageService } from 'src/app/shared/services/societe-linked/periode-sage.service';
import { ModalAnnulationConfirmationComponent } from '../modal-annulation-confirmation/modal-annulation-confirmation.component';
import { ModalInfoOkComponent } from '../info-ok/modal-info-ok.component';
import { getMonth } from 'src/app/shared/constants/month';

export interface DialogData {
    form: UntypedFormGroup;
    societeId: number;
    result: boolean;
  }
  @Component({
    selector: 'app-modal-add-periode-sage',
    templateUrl: './modal-add-periode-sage.component.html',
    styleUrls: ['./modal-add-periode-sage.component.scss']
  })
  export class ModalAddPeriodeSageComponent implements OnInit {
    form: UntypedFormGroup;
    constructor(public dialog: MatDialog
              , public dialogRef: MatDialogRef<GestionCgChargeComponent>
              , @Inject(MAT_DIALOG_DATA) public data: DialogData
              , private toastr: ToastrService
              , private router: Router
              , private periodeSageService: PeriodeSageService) {
               }

  ngOnInit(): void {
    this.form = this.data.form;
    if (!this.form.get('id').value){
      // initialise a la fin du mois de la periode 
      this.form.get('date').setValue(new Date(this.form.get('annee').value, this.form.get('mois').value, 0)) ;
    }

  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      var periode: PeriodeSageModel = this.form.getRawValue();
      // set UTC date to local time
      var myUtcDate = new Date(Date.UTC(
        periode.date.getFullYear(),
        periode.date.getMonth(),
        periode.date.getDate(),
        periode.date.getHours(),
        periode.date.getMinutes(),
        periode.date.getSeconds()
      ));
      periode.date = myUtcDate;

      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.periodeSageService.save(periode).subscribe((a: PeriodeSageModel) => {
            this.toastr.success('', 'Création de la période comptable du mois de ' + getMonth(a.mois) + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      } else { // Modification
        if(periode.statut === "Active" && periode.date.getDate() < new Date().getDate()){
          // add modal de confirmation dans ce cas car devient non modifiable
          const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
            data: {
              title: 'Modification de la periode active',
              message: 'Êtes-vous sur de vouloir rendre la periode active au statut clos ?',
              icone: 'warning_amber',
              iconColor: 'accent',
              color: 'accent'
            }
          });
            dialogConfirmation.afterClosed().subscribe((resultat) => {
              if (resultat) {
                const dialogRef = this.dialog.open(SpinnerModalComponent);
                this.periodeSageService.update(periode.id, periode).subscribe((a: PeriodeSageModel) => {
                  this.toastr.success('', 'Modification de la période comptable du mois de ' + getMonth(a.id) + ' réussie');
                  this.dialogRef.close(true);
                  dialogRef.close();
                }, (error) => {
                  this.dialogRef.close(true);
                  dialogRef.close();
                });
              }
            });
        }else {
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.periodeSageService.update(periode.id, periode).subscribe((a: PeriodeSageModel) => {
          this.toastr.success('', 'Modification de la période comptable du mois de ' + getMonth(a.id) + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
          }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
          });
        }
      }
    } else {
      this.displayErrors();
    }
  }

  displayErrors(): void {
    for (const index in this.form.errors) {
        this.form.controls[index].markAsTouched();
    }
  }
}

